import * as math from 'mathjs';
import {
  LineSegment,
  LineSegment2,
  MultiPolyline,
  MultiPolyline2,
  Polyline,
  Polyline2,
} from '../../geometric-types';

export function calculateSegmentLength(
  segment: LineSegment | LineSegment2
): number {
  return math.norm(math.subtract(segment[0], segment[1])) as number;
}

export function calculatePolylineLength(
  polyline: Polyline | Polyline2
): number {
  let totalLength = 0;
  for (let i = 0; i < polyline.length - 1; i++) {
    const segment = [polyline[i], polyline[i + 1]] as
      | LineSegment
      | LineSegment2;
    totalLength += calculateSegmentLength(segment);
  }
  return totalLength;
}

export function calculateMultiPolylineLength(
  polylines: MultiPolyline | MultiPolyline2
): number {
  let totalLength = 0;
  for (const polyline of polylines.lines) {
    totalLength += calculatePolylineLength(polyline);
  }
  return totalLength;
}
